import {useQuery} from "@tanstack/react-query";
import {getList} from "../../../app/getters/getList.js";


export const useOperatorzy = (enabled=true) => {
    return useQuery({
        queryKey: ['uzytkownicy_oper'],
        queryFn: async () => getList('/uzytkownicy/oper'),
        refetchOnMount: false,
        enabled
    })
}